var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVisionBlueprinting(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 200,
    height: 200,
    viewBox: "0 0 200 200",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_121_60057)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M49.043 162.831C47.651 156.384 43.7616 152.372 37.1904 150.94V49.0292C43.5773 47.6271 47.5896 43.728 49.0226 37.168H150.926C152.329 43.6666 156.32 47.6374 162.871 49.0394V150.929C159.903 151.513 157.211 152.73 155.031 154.91C152.84 157.09 151.52 159.731 150.988 162.831H49.043ZM116.668 98.0399C105.43 98.0399 94.1915 98.0399 82.9427 98.0399C80.4146 98.0399 79.9642 98.4697 79.9642 100.967C79.9642 118.539 79.9642 136.11 79.9642 153.682C79.9642 156.149 80.476 156.671 82.912 156.671C105.389 156.671 127.876 156.671 150.353 156.671C152.779 156.671 153.373 156.087 153.373 153.703C153.373 136.131 153.373 118.559 153.373 100.987C153.373 98.5516 152.84 98.0399 150.384 98.0399C139.145 98.0399 127.907 98.0399 116.658 98.0399H116.668ZM100.056 93.5983C103.373 93.0252 106.761 92.708 109.995 91.8176C120.527 88.9316 129.012 82.5251 137.037 75.4432C138.153 74.4607 137.989 73.2736 136.74 72.2195C131.469 67.7881 125.972 63.6843 119.882 60.4197C109.555 54.8933 98.8179 53.1944 87.5487 57.155C78.2242 60.4299 70.4146 66.1609 62.9734 72.4651C61.8271 73.4373 61.9499 74.7575 63.3112 75.7912C67.9069 79.2912 72.3798 82.9959 77.2211 86.1173C84.0993 90.5588 91.6633 93.2811 100.067 93.5881L100.056 93.5983ZM59.8516 127.882C64.4371 127.882 69.0123 127.882 73.5978 127.882C75.4402 127.882 76.4125 127.166 76.3614 125.866C76.3204 124.628 75.389 123.963 73.6387 123.963C64.478 123.963 55.3071 123.963 46.1464 123.963C44.304 123.963 43.3419 124.689 43.3829 125.989C43.4238 127.227 44.345 127.882 46.1055 127.882C50.6909 127.882 55.2662 127.882 59.8516 127.882ZM59.8516 147.153C55.215 147.153 50.5784 147.173 45.9417 147.143C44.5702 147.143 43.5364 147.511 43.3931 149.026C43.2805 150.264 44.3143 151.073 45.9827 151.073C55.2559 151.083 64.519 151.073 73.7923 151.073C75.1536 151.073 76.1874 150.622 76.3409 149.128C76.4637 147.88 75.4709 147.143 73.7513 147.143C69.1147 147.132 64.478 147.143 59.8414 147.143L59.8516 147.153ZM59.8926 104.712C61.5814 104.712 63.2703 104.712 64.9591 104.712C68.0707 104.712 71.172 104.712 74.2836 104.702C75.5221 104.702 76.2897 104.017 76.3307 102.829C76.3716 101.622 75.5835 100.946 74.3962 100.813C73.9663 100.762 73.5261 100.793 73.086 100.793C66.433 100.793 59.78 100.793 53.127 100.793C50.6193 100.793 48.1014 100.691 45.6039 100.864C44.8568 100.916 43.8946 101.622 43.5466 102.287C43.3112 102.748 43.823 103.822 44.304 104.324C44.6623 104.702 45.5118 104.702 46.1464 104.702C50.7216 104.733 55.3071 104.712 59.8926 104.723V104.712ZM62.9837 139.457C66.6275 139.457 70.2815 139.447 73.9253 139.457C75.1536 139.457 76.085 139.048 76.3307 137.748C76.5661 136.458 75.5221 135.537 73.782 135.527C66.648 135.507 59.5139 135.517 52.3798 135.527C50.65 135.527 49.7186 136.243 49.7083 137.492C49.7083 138.751 50.5988 139.437 52.3593 139.447C55.9008 139.467 59.4422 139.447 62.9837 139.447V139.457ZM55.7984 112.408C52.5231 112.408 49.2477 112.429 45.9724 112.408C44.6111 112.398 43.5569 112.756 43.4033 114.281C43.2805 115.52 44.304 116.338 45.9827 116.338C52.5333 116.359 59.084 116.359 65.6346 116.338C67.303 116.338 68.3368 115.509 68.214 114.271C68.0604 112.746 66.996 112.388 65.6346 112.398C62.3593 112.429 59.084 112.398 55.8086 112.398L55.7984 112.408ZM74.5497 46.6344C73.9765 47.1052 73.0758 47.4736 72.9632 48.016C72.8097 48.7324 73.0246 49.807 73.5057 50.3391C75.6039 52.6316 77.8455 54.7807 80.0461 56.9708C80.998 57.9123 82.0625 58.1477 83.0553 57.1243C83.9867 56.1623 83.7513 55.1287 82.8608 54.2281C80.6295 51.9868 78.3982 49.7456 76.1362 47.5453C75.7677 47.1871 75.2252 47.0131 74.5497 46.6344ZM127.549 48.6812C127.047 48.0672 126.689 47.2178 126.187 47.1257C125.45 46.9926 124.376 47.1461 123.854 47.6169C121.561 49.7046 119.422 51.9664 117.221 54.1564C116.269 55.098 115.983 56.1521 116.975 57.1652C117.979 58.1886 119.053 57.8816 119.985 56.9503C122.155 54.8012 124.325 52.652 126.443 50.462C126.873 50.0219 127.109 49.3976 127.549 48.6812ZM98.0604 45.3757C98.0604 46.3581 98.0093 47.3406 98.0707 48.3128C98.1423 49.4693 98.9202 50.2675 99.9642 50.0833C100.691 49.9605 101.766 49.1111 101.837 48.4868C102.083 46.5014 102.083 44.4546 101.837 42.4692C101.766 41.8449 100.711 41.0057 99.9847 40.8522C98.91 40.6373 98.1628 41.456 98.0707 42.592C97.999 43.5131 98.0604 44.4444 98.0502 45.3654L98.0604 45.3757Z",
    fill: "url(#paint0_linear_121_60057)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.01 154.767C170.537 154.829 175.072 159.475 175 165.001C174.928 170.528 170.261 175.092 164.765 175C159.227 174.908 154.683 170.251 154.765 164.756C154.846 159.219 159.473 154.706 165.01 154.767Z",
    fill: "url(#paint1_linear_121_60057)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.1945 154.768C40.7216 154.819 45.2969 159.485 45.2047 164.981C45.1126 170.548 40.4965 175.072 34.9796 175C29.432 174.929 24.9591 170.344 25 164.766C25.041 159.219 29.6367 154.706 35.1945 154.757V154.768Z",
    fill: "url(#paint2_linear_121_60057)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.1742 25.0001C40.732 25.0308 45.2867 29.6258 45.2049 35.1522C45.1332 40.7298 40.5682 45.202 35.0002 45.1509C29.4014 45.0997 24.9695 40.5967 25.0002 34.9885C25.0309 29.4007 29.5447 24.9796 35.1742 25.0001Z",
    fill: "url(#paint3_linear_121_60057)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.979 25.0002C170.537 25.0309 175.051 29.6157 175 35.1625C174.949 40.7196 170.353 45.2123 164.795 45.1509C159.217 45.0895 154.703 40.5149 154.765 34.9783C154.826 29.4315 159.401 24.9695 164.979 25.0002Z",
    fill: "url(#paint4_linear_121_60057)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.37 128.722V152.639H102.103V128.722H149.37Z",
    fill: "url(#paint5_linear_121_60057)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.073 102.031H149.35V124.546H102.073V102.031Z",
    fill: "url(#paint6_linear_121_60057)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.9376 152.69H84.0481V102.083H97.9376V152.69Z",
    fill: "url(#paint7_linear_121_60057)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.9283 74.0721C84.9488 65.7314 91.7144 59.0384 100.087 59.0793C108.408 59.1202 115.133 65.9463 115.072 74.2768C115.01 82.4947 108.204 89.2185 99.9641 89.2185C91.653 89.2185 84.8976 82.4128 84.9283 74.0721ZM90.1791 74.1438C90.1791 79.5371 94.5394 83.9275 99.913 83.9684C105.317 84.0094 109.831 79.5371 109.821 74.1233C109.821 68.689 105.379 64.2986 99.8925 64.3293C94.5189 64.3498 90.1689 68.7402 90.1791 74.1438Z",
    fill: "url(#paint8_linear_121_60057)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.2212 74.0108C72.6767 69.5692 78.1936 65.578 84.8261 62.4873C79.7493 70.3777 79.7186 77.91 84.8466 85.7697C78.1424 82.679 72.6357 78.5854 67.2212 74.0108Z",
    fill: "url(#paint9_linear_121_60057)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.184 85.8003C120.752 77.1525 119.657 69.2621 115.43 62.917C118.02 63.2957 128.071 69.7635 132.656 74.0618C127.405 78.6057 121.837 82.6379 115.184 85.8003Z",
    fill: "url(#paint10_linear_121_60057)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.036 68.2589C103.301 68.2794 105.942 70.9709 105.891 74.2253C105.839 77.3877 103.178 80.0178 100.015 80.0383C96.7606 80.0587 94.1096 77.3979 94.1096 74.123C94.1096 70.8379 96.7504 68.2384 100.036 68.2589Z",
    fill: "url(#paint11_linear_121_60057)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_121_60057",
    x1: 100.031,
    y1: 37.168,
    x2: 100.031,
    y2: 162.831,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4C135"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E98432"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_121_60057",
    x1: 164.882,
    y1: 154.767,
    x2: 164.882,
    y2: 175.001,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4C135"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E98432"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_121_60057",
    x1: 35.1029,
    y1: 154.757,
    x2: 35.1029,
    y2: 175.001,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4C135"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E98432"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_121_60057",
    x1: 35.103,
    y1: 25,
    x2: 35.103,
    y2: 45.1513,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4C135"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E98432"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_121_60057",
    x1: 164.882,
    y1: 25,
    x2: 164.882,
    y2: 45.1516,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4C135"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E98432"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_121_60057",
    x1: 125.737,
    y1: 128.722,
    x2: 125.737,
    y2: 152.639,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4C135"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E98432"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_121_60057",
    x1: 125.711,
    y1: 102.031,
    x2: 125.711,
    y2: 124.546,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4C135"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E98432"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_121_60057",
    x1: 90.9928,
    y1: 102.083,
    x2: 90.9928,
    y2: 152.69,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4C135"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E98432"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_121_60057",
    x1: 100,
    y1: 59.0791,
    x2: 100,
    y2: 89.2185,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4C135"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E98432"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_121_60057",
    x1: 76.0339,
    y1: 62.4873,
    x2: 76.0339,
    y2: 85.7697,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4C135"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E98432"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_121_60057",
    x1: 123.92,
    y1: 62.917,
    x2: 123.92,
    y2: 85.8003,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4C135"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E98432"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_121_60057",
    x1: 100,
    y1: 68.2588,
    x2: 100,
    y2: 80.0384,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4C135"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E98432"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_121_60057"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 150,
    height: 150,
    fill: "white",
    transform: "translate(25 25)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVisionBlueprinting);
export default __webpack_public_path__ + "static/media/Vision_Blueprinting.12873b40a459c41af028d1adfdce6df3.svg";
export { ForwardRef as ReactComponent };